import { __zcFin, __zcFinZ, __zcMkv, __zcPs } from "__zod-compiler-runtime__";
/* zod-compiler shared */
var __zcBf_0={};
import * as z from 'zod'

/**
 * Base schema for payloads passed from Rails backend to React templates.
 * All resource page payloads extend this base structure.
 */
export const BasePayloadSchema = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  z.object({
    contentfulRawJsonResponse: z.looseObject({}),
    userLoggedIn: z.boolean().optional(),
  }),
);
function __fc_1(input){var __w_0;return typeof input==="object"&&input!==null&&!Array.isArray(input)&&((__w_0=input["userLoggedIn"])===undefined||(typeof __w_0==="boolean"))&&typeof input["contentfulRawJsonResponse"]==="object"&&input["contentfulRawJsonResponse"]!==null&&!Array.isArray(input["contentfulRawJsonResponse"]);}
function __vb_2(input){var __bv_3,__bv_4,__bs_5,__bo_6;if(typeof input!=="object"||input===null||Array.isArray(input))return __zcBf_0;__bv_3=input["userLoggedIn"];if(!((__bv_3===undefined||(typeof __bv_3==="boolean"))))return __zcBf_0;__bv_4=input["contentfulRawJsonResponse"];if(!(typeof __bv_4==="object"&&__bv_4!==null&&!Array.isArray(__bv_4)))return __zcBf_0;__bs_5=__zcPs(__bv_4);__bo_6={"contentfulRawJsonResponse":__bs_5};if(__bv_3!==undefined||("userLoggedIn" in input)){__bo_6["userLoggedIn"]=__bv_3;}return __bo_6;}
var __rfm_z=__zs.safeParse;
function safeParse_BasePayloadSchema(input){
var __bd_7=__vb_2(input);
if(__bd_7!==__zcBf_0){return{success:true,data:__bd_7};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_BasePayloadSchema,__zs,null,__fc_1);
})()

export type BasePayload = z.infer<typeof BasePayloadSchema>

/**
 * @deprecated Use BasePayloadSchema instead
 */
export const PayloadSchema = /* @__PURE__ */ (() => {
var __zs=BasePayloadSchema;
function __fc_1(input){var __w_0;return typeof input==="object"&&input!==null&&!Array.isArray(input)&&((__w_0=input["userLoggedIn"])===undefined||(typeof __w_0==="boolean"))&&typeof input["contentfulRawJsonResponse"]==="object"&&input["contentfulRawJsonResponse"]!==null&&!Array.isArray(input["contentfulRawJsonResponse"]);}
function __vb_2(input){var __bv_3,__bv_4,__bs_5,__bo_6;if(typeof input!=="object"||input===null||Array.isArray(input))return __zcBf_0;__bv_3=input["userLoggedIn"];if(!((__bv_3===undefined||(typeof __bv_3==="boolean"))))return __zcBf_0;__bv_4=input["contentfulRawJsonResponse"];if(!(typeof __bv_4==="object"&&__bv_4!==null&&!Array.isArray(__bv_4)))return __zcBf_0;__bs_5=__zcPs(__bv_4);__bo_6={"contentfulRawJsonResponse":__bs_5};if(__bv_3!==undefined||("userLoggedIn" in input)){__bo_6["userLoggedIn"]=__bv_3;}return __bo_6;}
var __rfm_z=__zs.safeParse;
function safeParse_PayloadSchema(input){
var __bd_7=__vb_2(input);
if(__bd_7!==__zcBf_0){return{success:true,data:__bd_7};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_PayloadSchema,__zs,null,__fc_1);
})()
export type Payload = BasePayload

export function toPayload(payload: unknown): Payload {
  return BasePayloadSchema.parse(payload)
}
